import type { RadioStation } from '@/mocks/radios';

/* ── Radios Destacadas (Top / Premium / Score alto) ── */
export const featuredRadios: RadioStation[] = [
  {
    id: 0,
    name: "RFW Radio",
    slug: "rfw-radio",
    frequency: "87.00 RFW",
    city: "Global",
    state: "Plataforma RFW",
    category: "Oficial",
    language: "Español",
    hostName: "RFW Oficial",
    listeners: 15820,
    rating: 5.0,
    isLive: true,
    logoUrl: "https://readdy.ai/api/search-image?query=RFW%20Radio%20official%20logo%20design%2C%20circular%20modern%20emblem%20with%20radio%20waves%20and%20star%2C%20minimalist%20professional%20broadcast%20identity%2C%20warm%20amber%20and%20coral%20gradient%20colors%2C%20clean%20geometric%20shapes%2C%20isolated%20on%20transparent%20background%2C%20vector%20flat%20style&width=300&height=400&seq=discovery-rfw-logo&orientation=portrait",
    description: "La estación oficial de RadioFrecuenciaRFW.",
    radioScore: 10.0,
    cabinaMessages: 1240,
    recentPosts: 85,
    isPremium: true,
    isTopRadio: true,
    cabinaActiva: true,
    hostingType: 'rfw_hosting',
    providerType: 'rfw_hosted',
    streamProvider: 'icecast',
    streamUrl: 'https://stream.rfwradio.com:8000/rfw-live',
    streamStatus: 'online'
  },
  {
    id: 3,
    name: "La Mexicana FM",
    slug: "la-mexicana-fm",
    frequency: "103.50 RFW",
    city: "Houston",
    state: "Texas",
    category: "Regional Mexicana",
    language: "Español",
    hostName: "Don Fernando Ramírez",
    listeners: 12450,
    rating: 4.8,
    isLive: true,
    logoUrl: "https://readdy.ai/api/search-image?query=Mexican%20regional%20radio%20station%20logo%20with%20guitar%20and%20sombrero%20elements%2C%20circular%20design%20warm%20orange%20and%20green%20colors%2C%20clean%20modern%20broadcast%20style%2C%20festive%20vibrant%20feel%2C%20isolated%20on%20transparent%20background%2C%20vector%20flat%20design&width=300&height=400&seq=discovery-mexicana&orientation=portrait",
    description: "El sonido auténtico de México.",
    radioScore: 9.1,
    cabinaMessages: 567,
    recentPosts: 35,
    isPremium: true,
    isTopRadio: true,
    cabinaActiva: true,
    hostingType: 'external',
    providerType: 'custom_url',
    streamProvider: 'external',
    streamUrl: 'https://stream.lamexicana.com:8000/regional',
    streamStatus: 'online'
  },
  {
    id: 7,
    name: "Deportes Total Radio",
    slug: "deportes-total-radio",
    frequency: "120.00 RFW",
    city: "Dallas",
    state: "Texas",
    category: "Deportes",
    language: "Español",
    hostName: "Jorge Ruiz",
    listeners: 10890,
    rating: 4.8,
    isLive: true,
    logoUrl: "https://readdy.ai/api/search-image?query=Sports%20radio%20station%20logo%20with%20soccer%20ball%20and%20trophy%20icon%2C%20circular%20design%20dark%20blue%20and%20gold%20color%20scheme%2C%20dynamic%20broadcast%20emblem%2C%20energetic%20sports%20feel%2C%20isolated%20on%20transparent%20background%2C%20vector%20flat%20design&width=300&height=400&seq=discovery-deportes&orientation=portrait",
    description: "La cobertura deportiva más completa.",
    radioScore: 9.3,
    cabinaMessages: 623,
    recentPosts: 41,
    isPremium: false,
    isTopRadio: true,
    cabinaActiva: true,
    hostingType: 'external',
    providerType: 'custom_url',
    streamProvider: 'external',
    streamUrl: 'https://stream.deportestotal.com:8000/sports',
    streamStatus: 'online'
  },
  {
    id: 19,
    name: "Radio Hip Hop Nation",
    slug: "radio-hip-hop-nation",
    frequency: "170.40 RFW",
    city: "Atlanta",
    state: "Georgia",
    category: "Hip Hop",
    language: "Inglés",
    hostName: "Big Mike & DJ Scratch",
    listeners: 14200,
    rating: 4.5,
    isLive: true,
    logoUrl: "https://readdy.ai/api/search-image?query=Hip%20hop%20radio%20station%20logo%20with%20turntable%20and%20graffiti%20style%20crown%2C%20circular%20design%20bold%20black%20and%20gold%20colors%2C%20urban%20broadcast%20emblem%2C%20street%20music%20culture%20feel%2C%20isolated%20on%20transparent%20background%2C%20vector%20flat%20design&width=300&height=400&seq=discovery-hiphop&orientation=portrait",
    description: "Hip hop, rap y cultura urbana.",
    radioScore: 9.2,
    cabinaMessages: 698,
    recentPosts: 44,
    isPremium: false,
    isTopRadio: true,
    cabinaActiva: true,
    hostingType: 'external',
    providerType: 'direct_server',
    streamProvider: 'shoutcast',
    streamUrl: 'https://stream.hiphopnation.com:9000/hiphop',
    streamStatus: 'online'
  },
  {
    id: 12,
    name: "Banda Radio MX",
    slug: "banda-radio-mx",
    frequency: "200.00 RFW",
    city: "San Antonio",
    state: "Texas",
    category: "Regional Mexicana",
    language: "Español",
    hostName: "El Compa Chuy",
    listeners: 9780,
    rating: 4.6,
    isLive: true,
    logoUrl: "https://readdy.ai/api/search-image?query=Mexican%20banda%20music%20radio%20station%20logo%20with%20trumpet%20and%20accordion%2C%20circular%20design%20red%20white%20and%20green%20colors%2C%20festive%20broadcast%20emblem%2C%20traditional%20Mexican%20vibe%2C%20isolated%20on%20transparent%20background%2C%20vector%20flat%20design&width=300&height=400&seq=discovery-banda&orientation=portrait",
    description: "Pura banda, norteño y regional mexicano.",
    radioScore: 8.8,
    cabinaMessages: 432,
    recentPosts: 29,
    isPremium: false,
    isTopRadio: true,
    cabinaActiva: true,
    hostingType: 'external',
    providerType: 'custom_url',
    streamProvider: 'external',
    streamUrl: 'https://stream.bandaradiomx.com:8000/banda',
    streamStatus: 'online'
  },
  {
    id: 16,
    name: "Radio Salsa Brava",
    slug: "radio-salsa-brava",
    frequency: "110.70 RFW",
    city: "San Juan",
    state: "Puerto Rico",
    category: "Salsa",
    language: "Español",
    hostName: "Carlos Vega",
    listeners: 10550,
    rating: 4.9,
    isLive: true,
    logoUrl: "https://readdy.ai/api/search-image?query=Salsa%20music%20radio%20station%20logo%20with%20congas%20and%20tropical%20palm%20silhouette%2C%20circular%20design%20vibrant%20orange%20and%20yellow%20colors%2C%20festive%20Caribbean%20broadcast%20emblem%2C%20energetic%20Latin%20rhythm%20feel%2C%20isolated%20on%20transparent%20background%2C%20vector%20flat%20design&width=300&height=400&seq=discovery-salsa&orientation=portrait",
    description: "La mejor salsa, timba y son cubano.",
    radioScore: 9.5,
    cabinaMessages: 512,
    recentPosts: 38,
    isPremium: false,
    isTopRadio: true,
    cabinaActiva: true,
    hostingType: 'external',
    providerType: 'custom_url',
    streamProvider: 'external',
    streamUrl: 'https://stream.salsabrava.com:8000/salsa',
    streamStatus: 'online'
  },
  {
    id: 14,
    name: "Electro Vibes FM",
    slug: "electro-vibes-fm",
    frequency: "96.50 RFW",
    city: "Miami",
    state: "Florida",
    category: "Electrónica",
    language: "Inglés",
    hostName: "DJ Spark & MC Luna",
    listeners: 8120,
    rating: 4.5,
    isLive: true,
    logoUrl: "https://readdy.ai/api/search-image?query=Electronic%20music%20radio%20station%20logo%20with%20synthesizer%20waveform%20and%20neon%20accents%2C%20circular%20design%20vibrant%20cyan%20and%20magenta%20colors%2C%20futuristic%20broadcast%20emblem%2C%20energetic%20club%20music%20feel%2C%20isolated%20on%20transparent%20background%2C%20vector%20flat%20design&width=300&height=400&seq=discovery-electro&orientation=portrait",
    description: "House, techno y electrónica 24/7.",
    radioScore: 8.6,
    cabinaMessages: 398,
    recentPosts: 31,
    isPremium: false,
    isTopRadio: true,
    cabinaActiva: true,
    hostingType: 'external',
    providerType: 'direct_server',
    streamProvider: 'shoutcast',
    streamUrl: 'https://stream.electrovibes.com:9000/electro',
    streamStatus: 'online'
  },
  {
    id: 9,
    name: "La Kalle 99.9",
    slug: "la-kalle-99-9",
    frequency: "99.90 RFW",
    city: "Phoenix",
    state: "Arizona",
    category: "Pop",
    language: "Español",
    hostName: "DJ Paula & Bryan",
    listeners: 6340,
    rating: 4.4,
    isLive: true,
    logoUrl: "https://readdy.ai/api/search-image?query=Pop%20music%20radio%20station%20logo%20with%20headphones%20and%20music%20equalizer%20bars%2C%20circular%20design%20vibrant%20pink%20and%20purple%20colors%2C%20modern%20youthful%20broadcast%20emblem%2C%20energetic%20style%2C%20isolated%20on%20transparent%20background%2C%20vector%20flat%20design&width=300&height=400&seq=discovery-kalle&orientation=portrait",
    description: "Los éxitos del momento.",
    radioScore: 8.4,
    cabinaMessages: 289,
    recentPosts: 22,
    isPremium: true,
    isTopRadio: true,
    cabinaActiva: true,
    hostingType: 'external',
    providerType: 'direct_server',
    streamProvider: 'shoutcast',
    streamUrl: 'https://stream.lakalle.com:9000/pop',
    streamStatus: 'online'
  },
];

/* ── Radios Nuevas (Recién unidas) ── */
export const newRadios: RadioStation[] = [
  {
    id: 20,
    name: "Radio Country Road",
    slug: "radio-country-road",
    frequency: "190.20 RFW",
    city: "Nashville",
    state: "Tennessee",
    category: "Country",
    language: "Inglés",
    hostName: "Billy Ray Thompson",
    listeners: 7230,
    rating: 4.4,
    isLive: true,
    logoUrl: "https://readdy.ai/api/search-image?query=Country%20music%20radio%20station%20logo%20with%20acoustic%20guitar%20and%20cowboy%20hat%2C%20circular%20design%20warm%20brown%20and%20cream%20colors%2C%20rustic%20broadcast%20emblem%2C%20authentic%20Nashville%20country%20feel%2C%20isolated%20on%20transparent%20background%2C%20vector%20flat%20design&width=300&height=400&seq=discovery-country&orientation=portrait",
    description: "Country clásico y moderno.",
    radioScore: 7.8,
    cabinaMessages: 324,
    recentPosts: 23,
    isPremium: false,
    isTopRadio: false,
    cabinaActiva: true,
    hostingType: 'external',
    providerType: 'custom_url',
    streamProvider: 'external',
    streamUrl: 'https://stream.countryroad.com:8000/country',
    streamStatus: 'online'
  },
  {
    id: 18,
    name: "Radio Reggae Vibes",
    slug: "radio-reggae-vibes",
    frequency: "150.30 RFW",
    city: "Kingston",
    state: "Jamaica",
    category: "Reggae",
    language: "Inglés",
    hostName: "Rasta Mike",
    listeners: 5670,
    rating: 4.7,
    isLive: true,
    logoUrl: "https://readdy.ai/api/search-image?query=Reggae%20radio%20station%20logo%20with%20lion%20of%20Judah%20and%20palm%20tree%2C%20circular%20design%20vibrant%20green%20yellow%20and%20red%20colors%2C%20authentic%20Jamaican%20broadcast%20emblem%2C%20chilled%20island%20music%20feel%2C%20isolated%20on%20transparent%20background%2C%20vector%20flat%20design&width=300&height=400&seq=discovery-reggae&orientation=portrait",
    description: "Reggae, dancehall y ritmos caribeños.",
    radioScore: 8.3,
    cabinaMessages: 267,
    recentPosts: 19,
    isPremium: false,
    isTopRadio: false,
    cabinaActiva: true,
    hostingType: 'external',
    providerType: 'custom_url',
    streamProvider: 'external',
    streamUrl: 'https://stream.reggaevibes.com:8000/reggae',
    streamStatus: 'online'
  },
  {
    id: 13,
    name: "Jazz Nocturno Radio",
    slug: "jazz-nocturno-radio",
    frequency: "91.30 RFW",
    city: "Nueva Orleans",
    state: "Luisiana",
    category: "Jazz",
    language: "Inglés",
    hostName: "Robert Blue Johnson",
    listeners: 3456,
    rating: 4.8,
    isLive: true,
    logoUrl: "https://readdy.ai/api/search-image?query=Jazz%20radio%20station%20logo%20with%20saxophone%20and%20crescent%20moon%2C%20circular%20design%20deep%20amber%20and%20warm%20gold%20colors%2C%20smooth%20sophisticated%20broadcast%20emblem%2C%20classic%20New%20Orleans%20jazz%20feel%2C%20isolated%20on%20transparent%20background%2C%20vector%20flat%20design&width=300&height=400&seq=discovery-jazz&orientation=portrait",
    description: "El mejor jazz clásico y contemporáneo.",
    radioScore: 8.2,
    cabinaMessages: 210,
    recentPosts: 15,
    isPremium: false,
    isTopRadio: false,
    cabinaActiva: true,
    hostingType: 'external',
    providerType: 'direct_server',
    streamProvider: 'icecast',
    streamUrl: 'https://stream.jazznocturno.com:8000/jazz',
    streamStatus: 'online'
  },
  {
    id: 15,
    name: "Radio Infantil Aventura",
    slug: "radio-infantil-aventura",
    frequency: "97.80 RFW",
    city: "Orlando",
    state: "Florida",
    category: "Infantil",
    language: "Español",
    hostName: "Tía Rosita",
    listeners: 1890,
    rating: 4.8,
    isLive: false,
    logoUrl: "https://readdy.ai/api/search-image?query=Childrens%20radio%20station%20logo%20with%20cartoon%20rocket%20and%20stars%2C%20circular%20design%20playful%20bright%20orange%20and%20yellow%20colors%2C%20fun%20educational%20broadcast%20emblem%2C%20kid%20friendly%20cheerful%20style%2C%20isolated%20on%20transparent%20background%2C%20vector%20flat%20design&width=300&height=400&seq=discovery-infantil&orientation=portrait",
    description: "Contenido educativo y divertido.",
    radioScore: 6.2,
    cabinaMessages: 45,
    recentPosts: 7,
    isPremium: false,
    isTopRadio: false,
    cabinaActiva: false,
    hostingType: 'external',
    providerType: 'custom_url',
    streamProvider: 'external',
    streamUrl: '',
    streamStatus: 'pending'
  },
  {
    id: 11,
    name: "Radio Vida Nueva",
    slug: "radio-vida-nueva",
    frequency: "180.00 RFW",
    city: "Orlando",
    state: "Florida",
    category: "Cristiana",
    language: "Español",
    hostName: "Hermano José Luis",
    listeners: 4156,
    rating: 4.7,
    isLive: true,
    logoUrl: "https://readdy.ai/api/search-image?query=Christian%20worship%20radio%20station%20logo%20with%20cross%20and%20sunrise%20symbols%2C%20circular%20design%20soft%20blue%20and%20white%20colors%2C%20peaceful%20spiritual%20broadcast%20emblem%2C%20minimalist%20style%2C%20isolated%20on%20transparent%20background%2C%20vector%20flat%20design&width=300&height=400&seq=discovery-vidanueva&orientation=portrait",
    description: "Música de adoración y mensajes inspiradores.",
    radioScore: 7.5,
    cabinaMessages: 178,
    recentPosts: 16,
    isPremium: false,
    isTopRadio: false,
    cabinaActiva: true,
    hostingType: 'rfw_hosting',
    providerType: 'rfw_hosted',
    streamProvider: 'icecast',
    streamUrl: 'https://stream.rfwradio.com/vida-nueva',
    streamStatus: 'online'
  },
  {
    id: 5,
    name: "Rock Total Radio",
    slug: "rock-total-radio",
    frequency: "87.01 RFW",
    city: "Los Ángeles",
    state: "California",
    category: "Rock",
    language: "Español",
    hostName: "Alex Metal Torres",
    listeners: 7234,
    rating: 4.6,
    isLive: true,
    logoUrl: "https://readdy.ai/api/search-image?query=Rock%20radio%20station%20logo%20with%20electric%20guitar%20and%20lightning%20bolt%2C%20circular%20design%20black%20and%20red%20color%20scheme%2C%20modern%20rock%20broadcast%20emblem%2C%20energetic%20and%20bold%20style%2C%20isolated%20on%20transparent%20background%2C%20vector%20flat%20design&width=300&height=400&seq=discovery-rock&orientation=portrait",
    description: "Rock clásico y contemporáneo.",
    radioScore: 8.1,
    cabinaMessages: 312,
    recentPosts: 25,
    isPremium: false,
    isTopRadio: true,
    cabinaActiva: true,
    hostingType: 'external',
    providerType: 'direct_server',
    streamProvider: 'icecast',
    streamUrl: 'https://stream.rocktotal.com:8000/rock',
    streamStatus: 'online'
  },
];

/* ── Radios Tendencia (Subiendo rápido) ── */
export const trendingRadios: RadioStation[] = [
  {
    id: 19,
    name: "Radio Hip Hop Nation",
    slug: "radio-hip-hop-nation",
    frequency: "170.40 RFW",
    city: "Atlanta",
    state: "Georgia",
    category: "Hip Hop",
    language: "Inglés",
    hostName: "Big Mike & DJ Scratch",
    listeners: 14200,
    rating: 4.5,
    isLive: true,
    logoUrl: "https://readdy.ai/api/search-image?query=Hip%20hop%20radio%20station%20logo%20with%20turntable%20and%20graffiti%20style%20crown%2C%20circular%20design%20bold%20black%20and%20gold%20colors%2C%20urban%20broadcast%20emblem%2C%20street%20music%20culture%20feel%2C%20isolated%20on%20transparent%20background%2C%20vector%20flat%20design&width=300&height=400&seq=trend-hiphop&orientation=portrait",
    description: "Hip hop, rap y cultura urbana.",
    radioScore: 9.2,
    cabinaMessages: 698,
    recentPosts: 44,
    isPremium: false,
    isTopRadio: true,
    cabinaActiva: true,
    hostingType: 'external',
    providerType: 'direct_server',
    streamProvider: 'shoutcast',
    streamUrl: 'https://stream.hiphopnation.com:9000/hiphop',
    streamStatus: 'online'
  },
  {
    id: 0,
    name: "RFW Radio",
    slug: "rfw-radio",
    frequency: "87.00 RFW",
    city: "Global",
    state: "Plataforma RFW",
    category: "Oficial",
    language: "Español",
    hostName: "RFW Oficial",
    listeners: 15820,
    rating: 5.0,
    isLive: true,
    logoUrl: "https://readdy.ai/api/search-image?query=RFW%20Radio%20official%20logo%20design%2C%20circular%20modern%20emblem%20with%20radio%20waves%20and%20star%2C%20minimalist%20professional%20broadcast%20identity%2C%20warm%20amber%20and%20coral%20gradient%20colors%2C%20clean%20geometric%20shapes%2C%20isolated%20on%20transparent%20background%2C%20vector%20flat%20style&width=300&height=400&seq=trend-rfw&orientation=portrait",
    description: "La estación oficial de RadioFrecuenciaRFW.",
    radioScore: 10.0,
    cabinaMessages: 1240,
    recentPosts: 85,
    isPremium: true,
    isTopRadio: true,
    cabinaActiva: true,
    hostingType: 'rfw_hosting',
    providerType: 'rfw_hosted',
    streamProvider: 'icecast',
    streamUrl: 'https://stream.rfwradio.com:8000/rfw-live',
    streamStatus: 'online'
  },
  {
    id: 16,
    name: "Radio Salsa Brava",
    slug: "radio-salsa-brava",
    frequency: "110.70 RFW",
    city: "San Juan",
    state: "Puerto Rico",
    category: "Salsa",
    language: "Español",
    hostName: "Carlos Vega",
    listeners: 10550,
    rating: 4.9,
    isLive: true,
    logoUrl: "https://readdy.ai/api/search-image?query=Salsa%20music%20radio%20station%20logo%20with%20congas%20and%20tropical%20palm%20silhouette%2C%20circular%20design%20vibrant%20orange%20and%20yellow%20colors%2C%20festive%20Caribbean%20broadcast%20emblem%2C%20energetic%20Latin%20rhythm%20feel%2C%20isolated%20on%20transparent%20background%2C%20vector%20flat%20design&width=300&height=400&seq=trend-salsa&orientation=portrait",
    description: "La mejor salsa, timba y son cubano.",
    radioScore: 9.5,
    cabinaMessages: 512,
    recentPosts: 38,
    isPremium: false,
    isTopRadio: true,
    cabinaActiva: true,
    hostingType: 'external',
    providerType: 'custom_url',
    streamProvider: 'external',
    streamUrl: 'https://stream.salsabrava.com:8000/salsa',
    streamStatus: 'online'
  },
  {
    id: 14,
    name: "Electro Vibes FM",
    slug: "electro-vibes-fm",
    frequency: "96.50 RFW",
    city: "Miami",
    state: "Florida",
    category: "Electrónica",
    language: "Inglés",
    hostName: "DJ Spark & MC Luna",
    listeners: 8120,
    rating: 4.5,
    isLive: true,
    logoUrl: "https://readdy.ai/api/search-image?query=Electronic%20music%20radio%20station%20logo%20with%20synthesizer%20waveform%20and%20neon%20accents%2C%20circular%20design%20vibrant%20cyan%20and%20magenta%20colors%2C%20futuristic%20broadcast%20emblem%2C%20energetic%20club%20music%20feel%2C%20isolated%20on%20transparent%20background%2C%20vector%20flat%20design&width=300&height=400&seq=trend-electro&orientation=portrait",
    description: "House, techno y electrónica 24/7.",
    radioScore: 8.6,
    cabinaMessages: 398,
    recentPosts: 31,
    isPremium: false,
    isTopRadio: true,
    cabinaActiva: true,
    hostingType: 'external',
    providerType: 'direct_server',
    streamProvider: 'shoutcast',
    streamUrl: 'https://stream.electrovibes.com:9000/electro',
    streamStatus: 'online'
  },
  {
    id: 20,
    name: "Radio Country Road",
    slug: "radio-country-road",
    frequency: "190.20 RFW",
    city: "Nashville",
    state: "Tennessee",
    category: "Country",
    language: "Inglés",
    hostName: "Billy Ray Thompson",
    listeners: 7230,
    rating: 4.4,
    isLive: true,
    logoUrl: "https://readdy.ai/api/search-image?query=Country%20music%20radio%20station%20logo%20with%20acoustic%20guitar%20and%20cowboy%20hat%2C%20circular%20design%20warm%20brown%20and%20cream%20colors%2C%20rustic%20broadcast%20emblem%2C%20authentic%20Nashville%20country%20feel%2C%20isolated%20on%20transparent%20background%2C%20vector%20flat%20design&width=300&height=400&seq=trend-country&orientation=portrait",
    description: "Country clásico y moderno.",
    radioScore: 7.8,
    cabinaMessages: 324,
    recentPosts: 23,
    isPremium: false,
    isTopRadio: false,
    cabinaActiva: true,
    hostingType: 'external',
    providerType: 'custom_url',
    streamProvider: 'external',
    streamUrl: 'https://stream.countryroad.com:8000/country',
    streamStatus: 'online'
  },
  {
    id: 6,
    name: "Radio Comunitaria Unida",
    slug: "radio-comunitaria-unida",
    frequency: "87.02 RFW",
    city: "Chicago",
    state: "Illinois",
    category: "Comunitaria",
    language: "Español",
    hostName: "Colectivo Vecinal",
    listeners: 1567,
    rating: 4.3,
    isLive: true,
    logoUrl: "https://readdy.ai/api/search-image?query=Community%20radio%20station%20logo%20with%20people%20holding%20hands%20in%20circle%2C%20minimalist%20design%20with%20warm%20earth%20tones%2C%20green%20and%20orange%20colors%2C%20inclusive%20broadcast%20emblem%2C%20isolated%20on%20transparent%20background%2C%20vector%20flat%20design&width=300&height=400&seq=trend-comunitaria&orientation=portrait",
    description: "La voz de nuestra comunidad.",
    radioScore: 5.8,
    cabinaMessages: 67,
    recentPosts: 8,
    isPremium: false,
    isTopRadio: false,
    cabinaActiva: true,
    hostingType: 'external',
    providerType: 'custom_url',
    streamProvider: 'external',
    streamUrl: 'https://comunitariaunida.radio123.com:8000/stream',
    streamStatus: 'offline'
  },
];

/* ── Radios Cerca de Ti (Miami / Florida) ── */
export const nearbyRadios: RadioStation[] = [
  {
    id: 14,
    name: "Electro Vibes FM",
    slug: "electro-vibes-fm",
    frequency: "96.50 RFW",
    city: "Miami",
    state: "Florida",
    category: "Electrónica",
    language: "Inglés",
    hostName: "DJ Spark & MC Luna",
    listeners: 8120,
    rating: 4.5,
    isLive: true,
    logoUrl: "https://readdy.ai/api/search-image?query=Electronic%20music%20radio%20station%20logo%20with%20synthesizer%20waveform%20and%20neon%20accents%2C%20circular%20design%20vibrant%20cyan%20and%20magenta%20colors%2C%20futuristic%20broadcast%20emblem%2C%20energetic%20club%20music%20feel%2C%20isolated%20on%20transparent%20background%2C%20vector%20flat%20design&width=300&height=400&seq=near-electro&orientation=portrait",
    description: "House, techno y electrónica 24/7.",
    radioScore: 8.6,
    cabinaMessages: 398,
    recentPosts: 31,
    isPremium: false,
    isTopRadio: true,
    cabinaActiva: true,
    hostingType: 'external',
    providerType: 'direct_server',
    streamProvider: 'shoutcast',
    streamUrl: 'https://stream.electrovibes.com:9000/electro',
    streamStatus: 'online'
  },
  {
    id: 2,
    name: "Radio Fe y Esperanza",
    slug: "radio-fe-y-esperanza",
    frequency: "87.03 RFW",
    city: "Miami",
    state: "Florida",
    category: "Cristiana",
    language: "Español",
    hostName: "Pastora María Elena",
    listeners: 5632,
    rating: 4.9,
    isLive: true,
    logoUrl: "https://readdy.ai/api/search-image?query=Christian%20radio%20station%20logo%20with%20dove%20symbol%2C%20circular%20minimalist%20design%2C%20soft%20warm%20colors%20white%20and%20gentle%20golden%20tones%2C%20clean%20modern%20broadcast%20emblem%2C%20spiritual%20community%20radio%2C%20isolated%20on%20transparent%20background%2C%20vector%20style%20flat%20design&width=300&height=400&seq=near-fe&orientation=portrait",
    description: "Transmitiendo esperanza y fe.",
    radioScore: 8.7,
    cabinaMessages: 234,
    recentPosts: 18,
    isPremium: false,
    isTopRadio: true,
    cabinaActiva: true,
    hostingType: 'external',
    providerType: 'direct_server',
    streamProvider: 'shoutcast',
    streamUrl: 'https://stream.feyesperanza.com:9000/live',
    streamStatus: 'online'
  },
  {
    id: 11,
    name: "Radio Vida Nueva",
    slug: "radio-vida-nueva",
    frequency: "180.00 RFW",
    city: "Orlando",
    state: "Florida",
    category: "Cristiana",
    language: "Español",
    hostName: "Hermano José Luis",
    listeners: 4156,
    rating: 4.7,
    isLive: true,
    logoUrl: "https://readdy.ai/api/search-image?query=Christian%20worship%20radio%20station%20logo%20with%20cross%20and%20sunrise%20symbols%2C%20circular%20design%20soft%20blue%20and%20white%20colors%2C%20peaceful%20spiritual%20broadcast%20emblem%2C%20minimalist%20style%2C%20isolated%20on%20transparent%20background%2C%20vector%20flat%20design&width=300&height=400&seq=near-vidanueva&orientation=portrait",
    description: "Música de adoración y mensajes inspiradores.",
    radioScore: 7.5,
    cabinaMessages: 178,
    recentPosts: 16,
    isPremium: false,
    isTopRadio: false,
    cabinaActiva: true,
    hostingType: 'rfw_hosting',
    providerType: 'rfw_hosted',
    streamProvider: 'icecast',
    streamUrl: 'https://stream.rfwradio.com/vida-nueva',
    streamStatus: 'online'
  },
  {
    id: 15,
    name: "Radio Infantil Aventura",
    slug: "radio-infantil-aventura",
    frequency: "97.80 RFW",
    city: "Orlando",
    state: "Florida",
    category: "Infantil",
    language: "Español",
    hostName: "Tía Rosita",
    listeners: 1890,
    rating: 4.8,
    isLive: false,
    logoUrl: "https://readdy.ai/api/search-image?query=Childrens%20radio%20station%20logo%20with%20cartoon%20rocket%20and%20stars%2C%20circular%20design%20playful%20bright%20orange%20and%20yellow%20colors%2C%20fun%20educational%20broadcast%20emblem%2C%20kid%20friendly%20cheerful%20style%2C%20isolated%20on%20transparent%20background%2C%20vector%20flat%20design&width=300&height=400&seq=near-infantil&orientation=portrait",
    description: "Contenido educativo y divertido.",
    radioScore: 6.2,
    cabinaMessages: 45,
    recentPosts: 7,
    isPremium: false,
    isTopRadio: false,
    cabinaActiva: false,
    hostingType: 'external',
    providerType: 'custom_url',
    streamProvider: 'external',
    streamUrl: '',
    streamStatus: 'pending'
  },
  {
    id: 9,
    name: "La Kalle 99.9",
    slug: "la-kalle-99-9",
    frequency: "99.90 RFW",
    city: "Phoenix",
    state: "Arizona",
    category: "Pop",
    language: "Español",
    hostName: "DJ Paula & Bryan",
    listeners: 6340,
    rating: 4.4,
    isLive: true,
    logoUrl: "https://readdy.ai/api/search-image?query=Pop%20music%20radio%20station%20logo%20with%20headphones%20and%20music%20equalizer%20bars%2C%20circular%20design%20vibrant%20pink%20and%20purple%20colors%2C%20modern%20youthful%20broadcast%20emblem%2C%20energetic%20style%2C%20isolated%20on%20transparent%20background%2C%20vector%20flat%20design&width=300&height=400&seq=near-kalle&orientation=portrait",
    description: "Los éxitos del momento.",
    radioScore: 8.4,
    cabinaMessages: 289,
    recentPosts: 22,
    isPremium: true,
    isTopRadio: true,
    cabinaActiva: true,
    hostingType: 'external',
    providerType: 'direct_server',
    streamProvider: 'shoutcast',
    streamUrl: 'https://stream.lakalle.com:9000/pop',
    streamStatus: 'online'
  },
  {
    id: 5,
    name: "Rock Total Radio",
    slug: "rock-total-radio",
    frequency: "87.01 RFW",
    city: "Los Ángeles",
    state: "California",
    category: "Rock",
    language: "Español",
    hostName: "Alex Metal Torres",
    listeners: 7234,
    rating: 4.6,
    isLive: true,
    logoUrl: "https://readdy.ai/api/search-image?query=Rock%20radio%20station%20logo%20with%20electric%20guitar%20and%20lightning%20bolt%2C%20circular%20design%20black%20and%20red%20color%20scheme%2C%20modern%20rock%20broadcast%20emblem%2C%20energetic%20and%20bold%20style%2C%20isolated%20on%20transparent%20background%2C%20vector%20flat%20design&width=300&height=400&seq=near-rock&orientation=portrait",
    description: "Rock clásico y contemporáneo.",
    radioScore: 8.1,
    cabinaMessages: 312,
    recentPosts: 25,
    isPremium: false,
    isTopRadio: true,
    cabinaActiva: true,
    hostingType: 'external',
    providerType: 'direct_server',
    streamProvider: 'icecast',
    streamUrl: 'https://stream.rocktotal.com:8000/rock',
    streamStatus: 'online'
  },
];

/* ── Radios Más Escuchadas (Top listeners) ── */
export const mostListenedRadios: RadioStation[] = [
  {
    id: 0,
    name: "RFW Radio",
    slug: "rfw-radio",
    frequency: "87.00 RFW",
    city: "Global",
    state: "Plataforma RFW",
    category: "Oficial",
    language: "Español",
    hostName: "RFW Oficial",
    listeners: 15820,
    rating: 5.0,
    isLive: true,
    logoUrl: "https://readdy.ai/api/search-image?query=RFW%20Radio%20official%20logo%20design%2C%20circular%20modern%20emblem%20with%20radio%20waves%20and%20star%2C%20minimalist%20professional%20broadcast%20identity%2C%20warm%20amber%20and%20coral%20gradient%20colors%2C%20clean%20geometric%20shapes%2C%20isolated%20on%20transparent%20background%2C%20vector%20flat%20style&width=300&height=400&seq=top-rfw&orientation=portrait",
    description: "La estación oficial de RadioFrecuenciaRFW.",
    radioScore: 10.0,
    cabinaMessages: 1240,
    recentPosts: 85,
    isPremium: true,
    isTopRadio: true,
    cabinaActiva: true,
    hostingType: 'rfw_hosting',
    providerType: 'rfw_hosted',
    streamProvider: 'icecast',
    streamUrl: 'https://stream.rfwradio.com:8000/rfw-live',
    streamStatus: 'online'
  },
  {
    id: 19,
    name: "Radio Hip Hop Nation",
    slug: "radio-hip-hop-nation",
    frequency: "170.40 RFW",
    city: "Atlanta",
    state: "Georgia",
    category: "Hip Hop",
    language: "Inglés",
    hostName: "Big Mike & DJ Scratch",
    listeners: 14200,
    rating: 4.5,
    isLive: true,
    logoUrl: "https://readdy.ai/api/search-image?query=Hip%20hop%20radio%20station%20logo%20with%20turntable%20and%20graffiti%20style%20crown%2C%20circular%20design%20bold%20black%20and%20gold%20colors%2C%20urban%20broadcast%20emblem%2C%20street%20music%20culture%20feel%2C%20isolated%20on%20transparent%20background%2C%20vector%20flat%20design&width=300&height=400&seq=top-hiphop&orientation=portrait",
    description: "Hip hop, rap y cultura urbana.",
    radioScore: 9.2,
    cabinaMessages: 698,
    recentPosts: 44,
    isPremium: false,
    isTopRadio: true,
    cabinaActiva: true,
    hostingType: 'external',
    providerType: 'direct_server',
    streamProvider: 'shoutcast',
    streamUrl: 'https://stream.hiphopnation.com:9000/hiphop',
    streamStatus: 'online'
  },
  {
    id: 3,
    name: "La Mexicana FM",
    slug: "la-mexicana-fm",
    frequency: "103.50 RFW",
    city: "Houston",
    state: "Texas",
    category: "Regional Mexicana",
    language: "Español",
    hostName: "Don Fernando Ramírez",
    listeners: 12450,
    rating: 4.8,
    isLive: true,
    logoUrl: "https://readdy.ai/api/search-image?query=Mexican%20regional%20radio%20station%20logo%20with%20guitar%20and%20sombrero%20elements%2C%20circular%20design%20warm%20orange%20and%20green%20colors%2C%20clean%20modern%20broadcast%20style%2C%20festive%20vibrant%20feel%2C%20isolated%20on%20transparent%20background%2C%20vector%20flat%20design&width=300&height=400&seq=top-mexicana&orientation=portrait",
    description: "El sonido auténtico de México.",
    radioScore: 9.1,
    cabinaMessages: 567,
    recentPosts: 35,
    isPremium: true,
    isTopRadio: true,
    cabinaActiva: true,
    hostingType: 'external',
    providerType: 'custom_url',
    streamProvider: 'external',
    streamUrl: 'https://stream.lamexicana.com:8000/regional',
    streamStatus: 'online'
  },
  {
    id: 16,
    name: "Radio Salsa Brava",
    slug: "radio-salsa-brava",
    frequency: "110.70 RFW",
    city: "San Juan",
    state: "Puerto Rico",
    category: "Salsa",
    language: "Español",
    hostName: "Carlos Vega",
    listeners: 10550,
    rating: 4.9,
    isLive: true,
    logoUrl: "https://readdy.ai/api/search-image?query=Salsa%20music%20radio%20station%20logo%20with%20congas%20and%20tropical%20palm%20silhouette%2C%20circular%20design%20vibrant%20orange%20and%20yellow%20colors%2C%20festive%20Caribbean%20broadcast%20emblem%2C%20energetic%20Latin%20rhythm%20feel%2C%20isolated%20on%20transparent%20background%2C%20vector%20flat%20design&width=300&height=400&seq=top-salsa&orientation=portrait",
    description: "La mejor salsa, timba y son cubano.",
    radioScore: 9.5,
    cabinaMessages: 512,
    recentPosts: 38,
    isPremium: false,
    isTopRadio: true,
    cabinaActiva: true,
    hostingType: 'external',
    providerType: 'custom_url',
    streamProvider: 'external',
    streamUrl: 'https://stream.salsabrava.com:8000/salsa',
    streamStatus: 'online'
  },
  {
    id: 7,
    name: "Deportes Total Radio",
    slug: "deportes-total-radio",
    frequency: "120.00 RFW",
    city: "Dallas",
    state: "Texas",
    category: "Deportes",
    language: "Español",
    hostName: "Jorge Ruiz",
    listeners: 10890,
    rating: 4.8,
    isLive: true,
    logoUrl: "https://readdy.ai/api/search-image?query=Sports%20radio%20station%20logo%20with%20soccer%20ball%20and%20trophy%20icon%2C%20circular%20design%20dark%20blue%20and%20gold%20color%20scheme%2C%20dynamic%20broadcast%20emblem%2C%20energetic%20sports%20feel%2C%20isolated%20on%20transparent%20background%2C%20vector%20flat%20design&width=300&height=400&seq=top-deportes&orientation=portrait",
    description: "La cobertura deportiva más completa.",
    radioScore: 9.3,
    cabinaMessages: 623,
    recentPosts: 41,
    isPremium: false,
    isTopRadio: true,
    cabinaActiva: true,
    hostingType: 'external',
    providerType: 'custom_url',
    streamProvider: 'external',
    streamUrl: 'https://stream.deportestotal.com:8000/sports',
    streamStatus: 'online'
  },
  {
    id: 12,
    name: "Banda Radio MX",
    slug: "banda-radio-mx",
    frequency: "200.00 RFW",
    city: "San Antonio",
    state: "Texas",
    category: "Regional Mexicana",
    language: "Español",
    hostName: "El Compa Chuy",
    listeners: 9780,
    rating: 4.6,
    isLive: true,
    logoUrl: "https://readdy.ai/api/search-image?query=Mexican%20banda%20music%20radio%20station%20logo%20with%20trumpet%20and%20accordion%2C%20circular%20design%20red%20white%20and%20green%20colors%2C%20festive%20broadcast%20emblem%2C%20traditional%20Mexican%20vibe%2C%20isolated%20on%20transparent%20background%2C%20vector%20flat%20design&width=300&height=400&seq=top-banda&orientation=portrait",
    description: "Pura banda, norteño y regional mexicano.",
    radioScore: 8.8,
    cabinaMessages: 432,
    recentPosts: 29,
    isPremium: false,
    isTopRadio: true,
    cabinaActiva: true,
    hostingType: 'external',
    providerType: 'custom_url',
    streamProvider: 'external',
    streamUrl: 'https://stream.bandaradiomx.com:8000/banda',
    streamStatus: 'online'
  },
];

export const discoveryRows = [
  { title: 'Radios Destacadas', key: 'featured', data: featuredRadios, icon: 'ri-star-line' },
  { title: 'Radios Nuevas', key: 'new', data: newRadios, icon: 'ri-sparkling-line' },
  { title: 'Radios Tendencia', key: 'trending', data: trendingRadios, icon: 'ri-fire-line' },
  { title: 'Radios Cerca de Ti', key: 'nearby', data: nearbyRadios, icon: 'ri-map-pin-line' },
  { title: 'Radios Más Escuchadas', key: 'mostListened', data: mostListenedRadios, icon: 'ri-headphone-line' },
];